import React, { useState } from 'react';

const HorariosTable = ({ diasBase, onActualizar, loading = false }) => {
  const [editandoDia, setEditandoDia] = useState(null);
  const [tempData, setTempData] = useState({});

  const handleEditarDia = (dia) => {
    setEditandoDia(dia.id);
    setTempData(dia);
  };

  const handleGuardarDia = async () => {
    await onActualizar(editandoDia, tempData);
    setEditandoDia(null);
  };

  const handleCancelar = () => {
    setEditandoDia(null);
    setTempData({});
  };

  const nombresDias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

  const inputStyle = {
    border: '2px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '8px',
    padding: '0.5rem',
    fontSize: '0.9rem',
    width: '100%'
  };

  const buttonStyle = {
    padding: '0.5rem 0.75rem',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '600'
  };

  return (
    <div style={{ overflowX: 'auto', marginBottom: '2rem' }}>
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        backgroundColor: 'white',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
            <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', color: '#374151' }}>
              Día
            </th>
            <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', color: '#374151' }}>
              Estado
            </th>
            <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', color: '#374151' }}>
              Hora Inicio
            </th>
            <th style={{ padding: '1rem', textAlign: 'left', fontWeight: '700', color: '#374151' }}>
              Hora Fin
            </th>
            <th style={{ padding: '1rem', textAlign: 'center', fontWeight: '700', color: '#374151' }}>
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>
          {diasBase.map((dia) => (
            <tr
              key={dia.id}
              style={{
                borderBottom: '1px solid #e5e7eb',
                backgroundColor: editandoDia === dia.id ? '#f0f9ff' : 'white'
              }}
            >
              <td style={{ padding: '1rem', color: '#374151', fontWeight: '500' }}>
                {nombresDias[dia.dia_semana]}
              </td>
              <td style={{ padding: '1rem' }}>
                {editandoDia === dia.id ? (
                  <select
                    value={tempData.esta_abierto ? '1' : '0'}
                    onChange={(e) => setTempData({ ...tempData, esta_abierto: e.target.value === '1' })}
                    style={inputStyle}
                  >
                    <option value="1">Activo</option>
                    <option value="0">Cerrado</option>
                  </select>
                ) : (
                  <span style={{
                    display: 'inline-block',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '6px',
                    backgroundColor: dia.esta_abierto ? '#dcfce7' : '#fee2e2',
                    color: dia.esta_abierto ? '#166534' : '#991b1b',
                    fontSize: '0.9rem',
                    fontWeight: '600'
                  }}>
                    {dia.esta_abierto ? 'Abierto' : 'Cerrado'}
                  </span>
                )}
              </td>
              <td style={{ padding: '1rem' }}>
                {editandoDia === dia.id ? (
                  <input
                    type="time"
                    value={tempData.hora_apertura?.substring(0, 5) || ''}
                    onChange={(e) => setTempData({ ...tempData, hora_apertura: e.target.value })}
                    style={inputStyle}
                  />
                ) : (
                  <span style={{ color: '#6b7280' }}>{dia.hora_apertura?.substring(0, 5) || '--'}</span>
                )}
              </td>
              <td style={{ padding: '1rem' }}>
                {editandoDia === dia.id ? (
                  <input
                    type="time"
                    value={tempData.hora_cierre?.substring(0, 5) || ''}
                    onChange={(e) => setTempData({ ...tempData, hora_cierre: e.target.value })}
                    style={inputStyle}
                  />
                ) : (
                  <span style={{ color: '#6b7280' }}>{dia.hora_cierre?.substring(0, 5) || '--'}</span>
                )}
              </td>
              <td style={{ padding: '1rem', textAlign: 'center' }}>
                {editandoDia === dia.id ? (
                  <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                    <button
                      onClick={handleGuardarDia}
                      style={{
                        ...buttonStyle,
                        backgroundColor: '#10b981',
                        color: 'white'
                      }}
                      disabled={loading}
                    >
                      Guardar
                    </button>
                    <button
                      onClick={handleCancelar}
                      style={{
                        ...buttonStyle,
                        backgroundColor: '#ef4444',
                        color: 'white'
                      }}
                    >
                      Cancelar
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => handleEditarDia(dia)}
                    style={{
                      ...buttonStyle,
                      backgroundColor: '#3b82f6',
                      color: 'white'
                    }}
                    disabled={loading}
                  >
                    Editar
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HorariosTable;
